import { arrayUtil } from './array';
import { dateUtil } from './date';
export * from './differs';

export const SHARED_UTILS = [arrayUtil, dateUtil];
